import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.title',
    defaultMessage: 'Configure course weight settings',
  },
  description: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.description',
    defaultMessage: 'Set default lesson, quiz, and test weights for this course. Total must equal 100.',
  },
  lessonWeightLabel: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.lesson-weight.label',
    defaultMessage: 'Lesson weight',
  },
  quizWeightLabel: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.quiz-weight.label',
    defaultMessage: 'Quiz weight',
  },
  testWeightLabel: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.test-weight.label',
    defaultMessage: 'Test weight',
  },
  validationMessage: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.validation',
    defaultMessage: 'Please enter a value between 0 and 100.',
  },
  totalValidationMessage: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.total-validation',
    defaultMessage: 'Lesson, quiz, and test weights must total 100.',
  },
  cancelButton: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.button.cancel',
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.button.save',
    defaultMessage: 'Save',
  },
  openButton: {
    id: 'course-authoring.course-outline.course-weight-settings-modal.button.open',
    defaultMessage: 'Weight settings',
  },
});

export default messages;
